export default __webpack_public_path__ + "static/media/addUser.145d4a29.svg";